export const API_URL = 'https://api.mirror.edunixsystem.com/'
